import { Component, OnDestroy, OnInit } from '@angular/core';
import { FunctionCallService } from 'src/app/shared/services/function-calls.service';
import { environment } from '../../../environments/environment';

import { Router } from '@angular/router';
import { AppNavigationService } from 'src/app/shared/services/app-navigation.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit, OnDestroy {

  constructor(private functionCallService: FunctionCallService,
              private appNavigationService: AppNavigationService,
              private router: Router
              ) { }

  version = environment.version;

  defferedPrompt = null;
  defferedPromptAvailable = false;

  showIOSOnlyInstallButton = true;

  ngOnInit(): void 
  {
    console.log('landing page - getting storedDefferedPrompt');

    this.functionCallService.storedDefferedPromptEvent$.forEach((event) => 
    {
      if(event != null && event != undefined)
      {
        this.defferedPromptAvailable = true;
      }
      else
      {
        this.defferedPromptAvailable = false;
      }      
      console.log(event);
      return; 
    });     


    this.functionCallService.addToHomeScreenIOSSubject.subscribe((data: any) => 
    {
      console.log('IOS landing - page', data);
      this.showIOSOnlyInstallButton = data;
    });       


    this.appNavigationService.hideBackButton();


  }

  ngOnDestroy(): void {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    this.appNavigationService.showBackButton();
  }

  addToHomescreen()  
  {
    this.functionCallService.addToHomeScreenService('addToHomeScreen');
  }

  addToHomescreenIOS()  
  {
    this.functionCallService.addToHomeScreenIOSService('addToHomeScreen');
  }  

  checkForUpdates()  
  {
    this.functionCallService.checkForUpdateService('checkForUpdate');
  }



  onScoreTracker(mode)
  {
    
    if(mode == 'practice')
    {
      this.router.navigate([ '/score-tracker', -1, 'basic' ], { queryParams: {'leagueID': -1, 'matchID': -1,'gameID': 1} });
    }

  }  

}
